import { FC, useEffect, useState } from 'react';
import PaymentInformation from '../../account-settings/PaymentInformation';
import { StoragePlanCardProps } from '../../../pages/auth/storage-plans/storage-plan-card/StoragePlanCard';
import Loader from '../../loader/Loader';
import { showToast } from '../../../services/toast.service';
import { getStoragePlans } from '../../../api/storagePlansApi';
import { toastMessages } from '../../../constants/errorMessages';
import { STORAGE_PLAN_CONSTANTS } from '../../../constants/common';
import './manageBillingInformation.scss';

type ManageBillingInformationProps = {
  locationState: { activeTab: number };
};

const ManageBillingInformation: FC<ManageBillingInformationProps> = ({ locationState }) => {
  const [storageRates, setStorageRates] = useState([
    { storagePlanId: 1, name: '', costInCents: 0, unitOfMeasurement: '', period: '' },
  ]);
  const [storageRatesLoading, setStorageRatesLoading] = useState<boolean>(false);

  const handleRates = async () => {
    let rates: StoragePlanCardProps[] = [];

    try {
      setStorageRatesLoading(true);
      rates = (await getStoragePlans()).data;
      if (rates) {
        setStorageRates(rates);
        setStorageRatesLoading(false);
      }
    } catch {
      showToast.error(toastMessages.SOMETHING_WENT_WRONG);
    }
  };

  useEffect(() => {
    handleRates();
  }, []);

  return (
    <>
      <div className="manage-billing-information">
        <div className="manage-billing-info__body">
          {
            <>
              {storageRatesLoading ? (
                <div className="storage-rates-loader">
                  <Loader addedSpace loaderSize="small" />
                </div>
              ) : (
                <PaymentInformation
                  header={''}
                  description={STORAGE_PLAN_CONSTANTS.STORAGE_RATES_SUBHEADER}
                  columnsData={storageRates?.map(storage => {
                    return {
                      storagePlanId: storage?.storagePlanId,
                      quantityHeader: storage?.name,
                      costHeader: storage?.costInCents,
                      unitOfMeasurement: storage?.unitOfMeasurement,
                      period: storage?.period,
                    };
                  })}
                />
              )}
            </>
          }
        </div>
      </div>
    </>
  );
};

export default ManageBillingInformation;
